export class CssUtils {
  public static clearDragStyle(style: CSSStyleDeclaration) {
    document.body.style.cursor = '';
    style.position = '';
    style.top = '';
    style.left = '';
    style.width = '';
    style.height = '';
    style.pointerEvents = '';
  }
  public static applyDraggingStyle(style: CSSStyleDeclaration, bounds: DOMRect) {
    document.body.style.setProperty('cursor', 'none', 'important');
    style.position = 'absolute';
    style.width = this.toPixels(bounds.width);
    style.height = this.toPixels(bounds.height);

    CssUtils.dragTo(style, bounds.left, bounds.top, bounds.height, bounds.width);

    style.pointerEvents = 'none';
  }

  public static dragTo(style: CSSStyleDeclaration, x: number, y: number, elementHeight: number, elementWidth: number) {
    //a small padding is required to avoid scrollbar apearing on the Y axis.
    //it should be kept really small. unit is in pixels.
    const safePadding = 5;

    const maxVerticalPosition = document.body.offsetHeight - elementHeight - safePadding;
    const maxHorizontalPosition = document.body.offsetWidth - elementWidth;

    //Compute the position of the element inside the browser window.
    //If the user is dragging it outside of the window creating scrollbar and
    //blank space, this code will keep it inside the boundaries of the window.
    const computedX = Math.max(0, Math.min(x, maxHorizontalPosition));
    const computedY = Math.max(0, Math.min(y, maxVerticalPosition));

    style.left = this.toPixels(computedX);
    style.top = this.toPixels(computedY);
  }

  private static toPixels(qty: number) {
    return `${qty}px`;
  }
}
